export default {
      id: "chat-usage",
      viewBox: "0 0 129 113",
      url: __webpack_public_path__ + "icons-sprite.626747e.svg#chat-usage",
      toString: function () {
        return this.url;
      }
    }